import {
  addListener,
  createListenerMiddleware,
  removeListener,
} from '@reduxjs/toolkit';
import type { RootState } from '../../types';
import type { AppDispatch } from '@/redux/store';

const listenerMiddleware = createListenerMiddleware();

export const addAppListener = addListener.withTypes<RootState, AppDispatch>();
export const removeAppListener = removeListener.withTypes<RootState, AppDispatch>();

export default listenerMiddleware;
